import React from 'react';
import AppControls from './AppControls';

// AI Controls — Per-App GenAI Policies (+ per-app prompt/response DLP overrides).
// Thin wrapper over the shared AppControls; Agentic Browser Policies are deferred.
const AIControls = (props) => <AppControls {...props} controlType="AI" />;

export default AIControls;
